import { useState } from "react";
import { fileUrl } from "@/lib/api";

/**
 * Square thumbnail of a watch, prefers the restored/"after" front photo
 * so users see the finished piece when possible, with a graceful fallback
 * to the before photo. Renders a placeholder frame when neither exists —
 * keeps row heights uniform in the inventory table.
 *
 * sizes:
 *   xs (32px)  → inventory list rows
 *   sm (48px)  → mobile card
 *   md (96px)  → detail header (tap to open full)
 *   lg (160px) → (future) hero slots
 */
const SIZES = {
  xs: "w-8 h-8",
  sm: "w-12 h-12",
  md: "w-24 h-24",
  lg: "w-40 h-40",
};

export default function WatchThumb({ watch, size = "xs", onClick, className = "" }) {
  const [broken, setBroken] = useState(false);
  const src = watch?.photo_after_front || watch?.photo_before_front || null;
  const sz = SIZES[size] || SIZES.xs;
  const url = src && !broken ? fileUrl(src) : null;
  const label = watch?.brand || "Watch";

  return (
    <div
      onClick={onClick}
      className={`${sz} ${onClick ? "cursor-pointer" : ""} shrink-0 rounded-sm overflow-hidden bg-[#EFE3B8] border border-[#8B6A1F]/30 flex items-center justify-center ${className}`}
      data-testid={`watch-thumb-${watch?.id || "none"}`}
    >
      {url ? (
        <img
          src={url}
          alt={label}
          onError={() => setBroken(true)}
          loading="lazy"
          className="w-full h-full object-cover"
        />
      ) : (
        <span className="text-[9px] uppercase tracking-wider text-[#8B6A1F]/60 select-none">
          {size === "xs" ? "—" : "no photo"}
        </span>
      )}
    </div>
  );
}
